import { Breadcrumbs as CommsUIBreadcrumbs } from '@uswitch/comms-ui.breadcrumbs'

import { usePageContext } from '~/contexts/page-context'

import * as styles from './styles'

const Breadcrumbs = () => {
  const { crumbs } = usePageContext()

  if (!crumbs.length) return null

  return (
    <div sx={styles.wrapper}>
      <CommsUIBreadcrumbs crumbs={crumbs} isBlackFriday={false} />
    </div>
  )
}

export default Breadcrumbs
